module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', _vm._l((_vm.items), function(item) {
    return _c('item-component', {
      attrs: {
        "item": item,
        "id": _vm.id
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c06643c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ItemsComponent.vue
// module id = 55
// module chunks = 1